<template>

  <div class="all">
    <headercon></headercon>
    <div class="anniu">
      <img :src="img1"
           alt=""
           @click="go"
           class="button">
      <img :src="img2"
           alt=""
           @click="go1"
           class="button1">
    </div>
  </div>
</template>

<script>
import headercon from './header'
export default {
  components: {
    headercon
  },
  data () {
    return {
      img: require('../assets/componylogo.png'),
      img1: require('../assets/buttonl.png'),
      img2: require('../assets/buttonr.png'),
      text: '首页',
      text1: '产品与服务',
      text2: '企业动态',
      text3: '资质荣誉',
      text4: '关于我们'

    }
  },
  methods: {

    go () {
      this.$router.push({ path: '/recruit' })
    },
    go1 () {
      this.$router.push({ path: '/map' })
    }

  }
}
</script>

<style scoped lang="less">
.all {
  background: url("../assets/abouts.jpg");
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  min-width: 1199px;
  /deep/ .li5 {
    list-style-type: none;
    float: left;
    border-radius: 25px;
    background: #fff;
    width: 100px;
    height: 30px;
    text-decoration: none;
    text-align: center;
    line-height: 30px;
    a {
      color: #757575;
      text-decoration: none;
    }
  }
  .anniu {
    display: flex;
    width: 100%;
    height: 70%;
    .button {
      margin-top: 19.5%;
      margin-left: 3%;
      width: 2%;
      height: 20%;
      text-align: center;
      line-height: 28px;
      background: linear-gradient(to right, #d5edfb, #eeffff);
      border: none;
      font-size: 80px;
      color: #62c3d0;
    }
  }
}
@media only screen and (min-width: 1781px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
  }
}
@media only screen and (min-width: 1601px) and (max-width: 1780px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
  }
}
@media only screen and (min-width: 1421px) and (max-width: 1600px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1420px) {
  .button1 {
    position: absolute;
    right: 3%;
    margin-top: 19.5%;
    width: 2%;
    height: 15%;
    text-align: center;
    line-height: 28px;
    background: linear-gradient(to left, #d5edfb, #eeffff);
    border: none;
    font-size: 80px;
    color: #62c3d0;
  }
}
@media only screen and (max-width: 1200px) {
  .anniu {
    position: relative;
    .button1 {
      position: absolute;
      left: 1100px;
      top: 230px;
      width: 24px;
      height: 73px;
      text-align: center;
      line-height: 28px;
      background: linear-gradient(to left, #d5edfb, #eeffff);
      border: none;
      font-size: 80px;
      color: #62c3d0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutus.vue